var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "google 1",
    clipPath: "url(#clip0_1509_12598)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M34.6403 14.8679L19.9562 14.8672C19.3078 14.8672 18.7822 15.3927 18.7822 16.0411V20.732C18.7822 21.3803 19.3078 21.906 19.9562 21.906H28.2253C27.3199 24.2559 25.6298 26.2239 23.4736 27.4743L26.9996 33.578C32.6557 30.3069 35.9996 24.5674 35.9996 18.1423C35.9996 17.2275 35.9321 16.5735 35.7973 15.8371C35.6948 15.2777 35.2091 14.8679 34.6403 14.8679Z",
    fill: "#167EE6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.0004 28.9556C13.9536 28.9556 10.4209 26.7445 8.52347 23.4727L2.41992 26.9907C5.52598 32.3739 11.3446 35.999 18.0004 35.999C21.2655 35.999 24.3464 35.1199 27.0004 33.5879V33.5795L23.4744 27.4757C21.8616 28.4111 19.9952 28.9556 18.0004 28.9556Z",
    fill: "#12B347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M27 33.5888V33.5804L23.474 27.4766C21.8612 28.4119 19.995 28.9564 18 28.9564V35.9999C21.2651 35.9999 24.3461 35.1208 27 33.5888Z",
    fill: "#0F993E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.04348 17.9994C7.04348 16.0047 7.58784 14.1386 8.52307 12.5258L2.41952 9.00781C0.879047 11.6535 0 14.726 0 17.9994C0 21.2729 0.879047 24.3454 2.41952 26.9911L8.52307 23.4731C7.58784 21.8603 7.04348 19.9941 7.04348 17.9994Z",
    fill: "#FFD500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M18.0004 7.04348C20.6393 7.04348 23.0632 7.98117 24.9566 9.54091C25.4236 9.92566 26.1025 9.89789 26.5304 9.47004L29.854 6.14637C30.3395 5.66093 30.3049 4.86633 29.7863 4.41647C26.6142 1.66451 22.4868 0 18.0004 0C11.3446 0 5.52598 3.6251 2.41992 9.00837L8.52347 12.5264C10.4209 9.25453 13.9536 7.04348 18.0004 7.04348Z",
    fill: "#FF4B26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M24.9562 9.54091C25.4232 9.92566 26.1022 9.89789 26.53 9.47004L29.8536 6.14637C30.339 5.66093 30.3044 4.86633 29.7859 4.41647C26.6138 1.66444 22.4864 0 18 0V7.04349C20.6388 7.04349 23.0629 7.98117 24.9562 9.54091Z",
    fill: "#D93F21"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1509_12598"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.d14f6c13f1cccba9eaee9c751e0f3b48.svg";
export { ForwardRef as ReactComponent };